import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VList,
    { attrs: { "data-qa": "select_modal_options" } },
    _vm._l(_vm.options, function (option, index) {
      return _c(
        VListItem,
        {
          key: index,
          staticClass: "select-modal-option",
          class: _vm.xSpaceClass,
          attrs: { "data-qa": "select_modal_options_item" },
          on: {
            click: function ($event) {
              return _vm.$emit("lpu-select-speciality:select-option", {
                option,
              })
            },
          },
        },
        [
          _c("div", { staticClass: "mr-2" }, [
            _c(
              "div",
              {
                staticClass: "text-body-1 text--text",
                attrs: { "data-qa": "select_modal_options_title" },
              },
              [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "ml-auto text-info--text ui-icon-arrow-right",
          }),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }